import { render, staticRenderFns } from "./iri-info.vue?vue&type=template&id=ad790802&scoped=true&"
import script from "./iri-info.vue?vue&type=script&lang=ts&"
export * from "./iri-info.vue?vue&type=script&lang=ts&"
import style0 from "./iri-info.vue?vue&type=style&index=0&id=ad790802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad790802",
  null
  
)

export default component.exports